import { render } from "./messageCardTask.vue?vue&type=template&id=bc2886d8&scoped=true"
import script from "./messageCardTask.vue?vue&type=script&lang=js"
export * from "./messageCardTask.vue?vue&type=script&lang=js"

import "./messageCardTask.vue?vue&type=style&index=0&id=bc2886d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2886d8"]])

export default __exports__